export default "__VITE_ASSET__B2NsCUCX__"